import MasterService from "./MasterService";

const RemittanceService = {
    ...MasterService,

    saveRemittancePayment(params: object) {
        return this.post('/remittance/saveRemittancePayment', params)
    },

    fetchRemittanceDetail(params: object) {
        return this.post('/remittance/remittanceDetail', params)
    },

    saveRemittanceDetails(params: object) {
        return this.post('/remittance/saveRemittanceDetail', params)
    },

    getRemittanceList(params: object) {
        return this.post('/remittance/remittanceList', params)
    },

    assignLead(params: object) {
        return this.post('/remittance/assignLead', params)
    },

    downloadSoa(params: object) {
        return this.post('/remittance/downloadSoa', params)
    },
    bulkRemittanceAssignee(params: object){
        return this.post('/remittance/bulkRemittanceAssignee',params)
    },
}

export default RemittanceService;